import { Box, H3, Typography } from '@vp/swan'
import { MarkdownWithTrackableLinks } from './MarkdownWithTrackableLinks'
import { getSeoZoneCtaTrackingConfig } from '../../utils/trackingUtils'
import { useTrackingContext } from '../../hooks/trackingContext'
import { type SeoTilesProps } from '../../types/homepageSeo'

export const SeoTiles = ({ zoneTiles, startTrackingPositionForTiles }: SeoTilesProps) => {
  const { sourcePagePath } = useTrackingContext()

  if (!Array.isArray(zoneTiles) || !zoneTiles.length) {
    return null
  }

  return (
    <>
      {zoneTiles.map((zoneTile, index) => {
        if (!zoneTile.tileTitle || !zoneTile.tileDescription) return null
        return (
          <Box key={`seo-zone-tile-${index}`} mb={index !== zoneTiles.length - 7 ? 7 : 0}>
            {zoneTile.tileTitle && <H3 fontSkin="body-standard-bold">{zoneTile.tileTitle}</H3>}
            {zoneTile.tileDescription && (
              <Typography fontSkin="body-standard">
                <MarkdownWithTrackableLinks
                  html={zoneTile.tileDescription}
                  getTrackingInfo={(destinationPagePath, ctaValue) =>
                    getSeoZoneCtaTrackingConfig(sourcePagePath, destinationPagePath, ctaValue, index + startTrackingPositionForTiles)
                  }
                />
              </Typography>
            )}
          </Box>
        )
      })}
    </>
  )
}
